// AppErrorBoundary — top-level boundary used as `errorElement` on the root
// route (see routes.tsx). React Router renders this when
// any child route throws during loader/render. Full-page <ErrorState> with a
// Reload CTA — a hard window.location.reload() so the next mount
// re-runs useAuthBootstrap().
import { useTranslation } from 'react-i18next';
import { ErrorState } from '../ui/index.js';

export function AppErrorBoundary() {
  const { t } = useTranslation(['shell', 'common']);
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-1)',
      }}
    >
      <ErrorState
        title={t('appError.title')}
        text={t('appError.text')}
        onRetry={() => {
          if (typeof window !== 'undefined') {
            window.location.reload();
          }
        }}
        retryLabel={t('common:actions.reload')}
      />
    </div>
  );
}
